<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the DEFAULT component for rendering the Duty activity end line (second line in a block)          -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <div class="pb-1">
    <v-row v-if="isTrain" class="DutyActivityEnd_JB">
      <v-col cols="9">
        {{ time(dutyActivity.toMinutesAfterMidnight) }}<span class="grey--text text--darken-1" v-if="dutyActivity.note"><br />{{ dutyActivity.note }}</span>
      </v-col>
      <v-col cols="2" class="text-right pr-0">{{ dutyStopsById[dutyActivity.endStopIdFk].longname }}</v-col>
      <v-col cols="1" class="d-flex justify-end pl-0">
        <time-line-point small :cellHeight="30" :themeName="themeName" :topConnection="true" :bottomConnection="false" :topMargin="3"></time-line-point>
      </v-col>
    </v-row>
    <v-row v-else class="DutyActivityEnd_JB">
      <v-col cols="9">{{ dutyActivity.note }}</v-col>
    </v-row>
  </div>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import TimeLinePoint from '../../../../components/decorators/TimeLinePoint.vue';

export default {
  name: 'DutyActivityEnd_Default',
  components: {
    TimeLinePoint,
  },
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
    isTrain() {
      return this.dutyActivity.activityShortname.endsWith('zug');
    },
    hasNote() {
      return this.dutyActivity.note ? true : false;
    },
    isVisible() {
      return this.isTrain || (!this.isTrain && this.hasNote);
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
